/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Triggers_Welcome_Open_AgentInputs */



/**
* | output |
* | --- |
* | "Open agent page" |
*
* @param {Agent_Triggers_Welcome_Open_AgentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_welcome_open_agent = /** @type {((inputs?: Agent_Triggers_Welcome_Open_AgentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_Welcome_Open_AgentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Agentenseite öffnen")
	return /** @type {LocalizedString} */ ("Open agent page")
});